import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { OperatorModule } from '~/store/modules/operator';

@Component({})
export default class UserRights extends Vue {
    @Prop({ default: false }) readonly showModeratorOnly: boolean | undefined;
    @Prop({ default: false }) readonly showSuperModeratorOnly: boolean | undefined;

    get isModerator() {
        return OperatorModule.isModerator;
    }

    get isSuperModerator() {
        return OperatorModule.isSuperModerator;
    }
    get checkHasRights() {
        // by default consider the user can see what is requested
        let hasRequestedRights = true;

        if (this.showSuperModeratorOnly) {
            hasRequestedRights = this.isSuperModerator;
        }

        return hasRequestedRights;
    }

    isAllowed(scope: string, action?: string) {
        return OperatorModule.isAllowed(scope, action);
    }

}
